// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2tcV0","right":"Footer_right__2bP6b","buttons":"Footer_buttons__24DkA"};